let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("guFtL")).then(() => parcelRequire('byO8e'));